import React, { useEffect, useMemo, useState } from 'react'
import Navbar from '../../Navbar';
import { Button, Container, IconButton, ListItemIcon, MenuItem, Tooltip, Typography } from '@mui/material';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import { getData } from '../../../services/library';
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Delete } from "@mui/icons-material";
import BajaTipoCliente from './baja/BajaTipoCliente';
import EdicionTipoCliente from './edicion/EdicionTipoCliente';
import AltaTipoCliente from './alta/AltaTipoCliente';
import MarcarActivoTipoCliente from './activo/MarcarActivoTipoCliente';

function TiposClientesEnvasado() {
const [tipos, setTipos] = useState(); //aca se almacenan los datos que me trae la api
    const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
    const [tabla, setTabla] = useState(true); //Estado q mostrará o no la tabla (pantalla inicial) dnd estan los clientes
    const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
    const [baja, setBaja] = useState(false); //Abre formulario
    const [dataTipo, setDataTipo] = useState({});
    const [marcarActivo, setMarcarActivo] = useState(false);
  
    //Tabla
    const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
    const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);
  
    //  Funcion para traer los clientes a la tabla : ACTIVOS
    const obtenerTiposInactivos = () => {
      setHiddenmuestrainactivo(true);
      setHiddenmuestraactivos(false);
      getData("/tipoclienteenvasado/inactivos", setTipos);
    };
  
    //Funcion para traer los clientes a la tabla TODOS :ACTIVOS E INACTIVOS
    const obtenerTipos = () => {
      setHiddenmuestraactivos(true);
      setHiddenmuestrainactivo(false);
      getData("/tipoclienteenvasado/", setTipos);
    };
  
    useEffect(() => {
      obtenerTipos();
    }, [tabla]);
  
    const handleClickNuevo = () => {
      setAlta(true);
    };
  
    const handleCloseEditar = () => {
      setEditar(false);
      setTabla(true);
      obtenerTipos();
    };
    const handleCloseAlta = () => {
      setAlta(false);
      setTabla(true);
      obtenerTipos();
    };
  
    const columns = useMemo(
      () => [
        {
          accessorKey: "id", //access nested data with dot notation
          header: "ID",
          maxSize: 100,
        },
        {
          accessorKey: "descripcion", //access nested data with dot notation
          header: "Descripción",
        },
      ],
      []
    );
  
    const muiSearchTextFieldProps = {
      placeholder: "Buscar..",
      sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
      variant: "outlined",
      color: "success",
      size: "small",
    };
  
    const initialState = {
      density: "compact",
      showGlobalFilter: true,
      pagination: { pageIndex: 0, pageSize: 10 },
    };
  
    const tableHeadCellProps = {
      align: "left",
      sx: {
        fontSize: 16,
        color: "white",
        fontWeight: "normal",
        backgroundColor: "#2471A3",
        borderColor: "black",
      },
    };
  
    const displayColumnDefOptions = {
      "mrt-row-actions": {
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
    };
  
    return (
      <>
        <Navbar />
        <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
          {tabla && (
            <MaterialReactTable
              localization={MRT_Localization_ES}
              columns={columns}
              data={tipos ?? [{}]}
              layoutMode={"grid"}
              initialState={initialState}
              enableColumnActions={false} //deshabilita las acciones POR COLUMNA
              enableGlobalFilterModes={false}
              enableHiding={false}
              enableRowActions={true}
              enableColumnFilters={false}
              enableFullScreenToggle={false}
              positionActionsColumn={"last"}
              enableExpandAll={false}
              enableToolbarInternalActions={true}
              muiTableHeadCellProps={tableHeadCellProps}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enableDensityToggle={false}
              displayColumnDefOptions={displayColumnDefOptions}
              enableColumnResizing={true}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
                sx: {
                  backgroundColor:
                    row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
                  color: "black",
                },
              })}
              renderTopToolbarCustomActions={() => (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxTwoToneIcon color="asd" />}
                    onClick={handleClickNuevo}
                  >
                    Nuevo Tipo
                  </Button>
                  <Typography variant="poster" fontSize={26}>
                    <ManageAccountsIcon sx={{ fontSize: 20 }} />
                    Tipos de Cliente Envasado
                  </Typography>
                </>
              )}
              renderToolbarInternalActions={() => (
                <>
                  {!hiddenmuestrainactivo ? (
                    <Tooltip title="Muestra Inactivos">
                      <IconButton
                        onClick={() => obtenerTiposInactivos()}
                        color="error"
                      >
                        <PersonOffIcon />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {!hiddenmuestraactivos ? (
                    <Tooltip title="Mostrar ACTIVOS" color="success">
                      <IconButton onClick={() => obtenerTipos()}>
                        <PersonIcon />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </>
              )}
              renderRowActionMenuItems={({ closeMenu, row, index }) => [
                <MenuItem
                  key={index}
                  style={{
                    display: row.original.activo === 0 ? null : "none",
                  }}
                  disabled={row.original.activo === 1}
                  onClick={() => {
                    setMarcarActivo(true);
                    setDataTipo(row.original);
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <CheckCircleOutlineIcon color="success" />
                  </ListItemIcon>
                  Marcar Activo
                </MenuItem>,
  
                <MenuItem
                  key={index}
                  style={{
                    display: row.original.activo === 0 ? "none" : null,
                  }}
                  disabled={row.original.activo === 0}
                  onClick={() => {
                    closeMenu();
                    setDataTipo(row.original);
                    setEditar(true);
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <BorderColorIcon color="primary" />
                  </ListItemIcon>
                  Editar
                </MenuItem>,
  
                <MenuItem
                  key={index}
                  style={{
                    display: row.original.activo === 0 ? "none" : null,
                  }}
                  disabled={row.original.activo === 0}
                  onClick={() => {
                    closeMenu();
                    setDataTipo(row.original);
                    setBaja(true);
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <Delete color="error" />
                  </ListItemIcon>
                  Marcar Inactivo
                </MenuItem>,
              ]}
            />
          )}
  
          {baja && (
            <BajaTipoCliente
              open={baja}
              setOpen={setBaja}
              tipo={dataTipo}
              tabla={setTabla}
              actualizar={obtenerTipos}
            />
          )}
          {editar ? (
            <EdicionTipoCliente
              editar={editar}
              datosRow={dataTipo}
              onClose={() => handleCloseEditar(false)}
            />
          ) : null}
          {alta ? (
            <AltaTipoCliente alta={alta} onClose={() => handleCloseAlta(false)} />
          ) : null}
          {marcarActivo ? (
            <MarcarActivoTipoCliente
              open={marcarActivo}
              setOpen={setMarcarActivo}
              tipo={dataTipo}
              tabla={setTabla}
              actualizar={obtenerTipos}
            />
          ) : null}
        </Container>
      </>
    );
  }

export default TiposClientesEnvasado